import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ContentWrapper from "../../styles/ContentWrapper";
import HeroHeader from "../../styles/HeroHeader";
import { BACKGROUND_COLOR } from "../../styles/Theme";

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
	const { t } = useTranslation();
	return (
		<Box minHeight="100vh" display="flex" flexDirection="column" bgcolor={BACKGROUND_COLOR} sx={{ gap: 6 }}>
			<HeroHeader />
			<ContentWrapper>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<Typography variant="h4" component="h1">
						{t("errorBoundary.heading")}
					</Typography>
					<Typography variant="body1">{t("errorBoundary.ingress")}</Typography>
					<Box padding={1}>
						<Typography variant="caption" display="block" color="error">
							{error.message}
						</Typography>
					</Box>
					<Button onClick={resetErrorBoundary} color="primary" variant="contained" sx={{ maxWidth: "300px" }}>
						{t("errorBoundary.tryAgain")}
					</Button>
					<Box>
						<Typography variant="body1">{t("errorBoundary.ifErrorPersists")}</Typography>
						<Typography variant="body1">
							<a href="mailto:support@smartocean.com">support@smartocean.com</a>
						</Typography>
					</Box>
				</Box>
			</ContentWrapper>
		</Box>
	);
}

export default ErrorFallback;
